import { TopicApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { GetAllTopicRequest, GetAllTopicResponse } from '@/types/http-payload/forum';
import { TopicDetail, TopicTableItem } from '@/types/topic';
import { TableState } from '@tanstack/react-table';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class TopicStore extends BaseStore {
    api: TopicApi;
    topicList: TopicTableItem[] = [];
    topicDetail: TopicDetail | null = null;
    totalByStatus: Object = {};

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            topicList: observable,
            topicDetail: observable,
            totalByStatus: observable,
            getAllTopic: flow.bound,
            getTopicDetail: flow.bound,
            updateTopic: flow.bound,
            updateTopicStatus: flow.bound,
            updateApproveTopic: flow.bound,
            deleteTopic: flow.bound,
            createTopic: flow.bound
        });
        this.api = new TopicApi();
    }

    *getAllTopic(searchParams?: GetAllTopicRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetAllTopicResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getAllTopic, payload);
            if (res?.ok) {
                this.topicList = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
                this.totalByStatus = res.data.totalByStatus;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getTopicDetail(code: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getTopicDetail, code);
            if (res.ok) {
                this.topicDetail = res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateTopic(code: string, data: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateTopic, { code, data });
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateTopicStatus(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateTopicStatus, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateApproveTopic(code: string, payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateApproveTopic, { code, data: payload });
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *deleteTopic(code: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteTopic, code);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *createTopic(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createTopic, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    clean(): void {
        super.clean();
        this.topicList = [];
    }
}
